import { render, staticRenderFns } from "./registered-judge-pool.vue?vue&type=template&id=3b6d501c&scoped=true&"
import script from "./registered-judge-pool.vue?vue&type=script&lang=js&"
export * from "./registered-judge-pool.vue?vue&type=script&lang=js&"
import style0 from "./registered-judge-pool.vue?vue&type=style&index=0&id=3b6d501c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6d501c",
  null
  
)

export default component.exports